import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Moon } from 'lucide-react';
export function StoryHook() {
  return <SectionWrapper bgColor="white" data-id="element-148">
      <div className="flex flex-col items-center text-center mb-8" data-id="element-149">
        <div className="bg-brand-sage p-4 rounded-full mb-6" data-id="element-150">
          <Moon className="w-8 h-8 text-brand-forest" data-id="element-151" />
        </div>
      </div>

      <div className="prose prose-lg max-w-none text-gray-700 space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-152">
        <p className="italic font-medium text-brand-forest text-xl md:text-2xl text-center mb-8" data-id="element-153">
          "Son las 11:30 de la noche. Acabas de disfrutar una cena deliciosa en
          familia, pero en cuanto intentas descansar, empieza ese ardor familiar
          subiendo por tu pecho."
        </p>

        <p data-id="element-154">
          Te sientas en la cama, buscas desesperadamente un antiácido y te
          resignas a otra noche de sueño interrumpido y malestar.
        </p>

        <p data-id="element-155">
          Esa "lava ácida" no es solo una molestia; es tu cuerpo gritando que ya
          no puede procesar la comida de la misma forma que lo hacía a los 20
          años.
        </p>

        <p className="font-bold text-brand-forest" data-id="element-156">
          Pero envejecer no tiene por qué significar renunciar a los Sabores que
          amas.
        </p>
      </div>
    </SectionWrapper>;
}